import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { StatusContatoAtivo } from '../interfaces/status-contato-ativo';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-status-contato-ativo',
  templateUrl: './status-contato-ativo.component.html',
  styleUrls: ['./status-contato-ativo.component.css']
})
export class StatusContatoAtivoComponent implements OnInit {

  @Input() grafico: StatusContatoAtivo;
  @Input() options: any;
  plugins = [pluginDataLabels];

  constructor() { }

  ngOnInit() {
    this.configGraf();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['grafico'] && changes['grafico'].currentValue) {
      this.configGraf();
    }
  }

  get possuiDados(): boolean {
    const dados = this.grafico?.datasets?.[0]?.data;
    return Array.isArray(dados) && dados.some(d => d > 0);
  }

  private configGraf() {
    this.options = {
      legend: {
        position: 'left',
        labels: {
          boxWidth: 20
        }
      },
      plugins: {
        datalabels: {
          color: '#fff',
          font: {
            weight: 'bold'
          },
          formatter: (value: number, context: any) => {
            const data = context.chart.data.datasets[0].data;
            const total = data.reduce((sum: number, val: number) => sum + val, 0);

            if (value === 0) return '';

            const percent = ((value / total) * 100).toFixed(1).replace('.', ',');
            return `${value} (${percent}%)`;
          }
        }
      },
      tooltips: {
        callbacks: {
          label: (tooltipItem, data) => {
            const index = tooltipItem.index;
            const label = data.labels[index];
            const value = data.datasets[0].data[index];

            if (label === 'Qualificados' && this.grafico.detalhes?.[label]) {
              const detalhes = this.grafico.detalhes[label];
              const linhas = [`Total: ${value}`];
              detalhes.forEach(item => {
                linhas.push(`${item.label}: ${item.valor}`);
              });
              return linhas;
            }

            return `${label}: ${value}`;
          }
        }
      }
    };
  }
}
